import HRIndexPage from '../../components/pages/humanResources/Index'
import DetailMember from "../../components/pages/humanResources/DetailMember";


const routes = [
  {
    path: '/me',
    name: 'me',
    component: DetailMember
  },
  {
    path: '/',
    name: 'index',
    component: HRIndexPage
  },

];

export default routes
